// src/components/Navbar.jsx

import React, { useState } from 'react';
import { NavLink , Link } from 'react-router-dom';
import '../styles/navStyle.css';

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <header className="navbar">
      <Link to="/">
        <img src="/assets/logo.jpg" alt="Mirror Lake Pharmacy Logo" className="logo" />
      </Link>

      <nav className={`nav-links ${menuOpen ? "open" : ""}`}>
        <NavLink to="/" end className="nav-item" onClick={() => setMenuOpen(false)}>
          Home
        </NavLink>
        <NavLink to="/about" className="nav-item" onClick={() => setMenuOpen(false)}>
          About
        </NavLink>
        <NavLink to="/services" className="nav-item" onClick={() => setMenuOpen(false)}>
          Services
        </NavLink>
        <NavLink to="/testimonials" className="nav-item" onClick={() => setMenuOpen(false)}>
          Testimonials
        </NavLink>
        <NavLink to="/contact" className="contact-btn" onClick={() => setMenuOpen(false)}>
          <p className='contact-btn-text'>Contact</p>
        </NavLink>
      </nav>

      <div className={`hamburger ${menuOpen ? "open" : ""}`} onClick={toggleMenu}>
        <div className="line"></div>
        <div className="line"></div>
        <div className="line"></div>
      </div>
    </header>
  );
}

export default Navbar;